import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { VerticalLayout } from "../../common/common-layout";
import { TitleMediumBold, TitleLargeMedium } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import { useEffect, useState } from "react";
import { formatDateToYMD } from "../../common/utils/DateUtils";
import CustomerReport from "../../model/homepage/CustomerReport";
import BTButton from "../../common/components/BTButton";
import theme from "../../common/theme";
import BTInputBox from "../../common/components/BTInputBox";
import Divider from "@mui/material/Divider";
import BTMultilineInputBox from "../../common/components/BTMultilineInputBox";

const CustomerReportsDetail = () => {
    return (
        <MainLayout>
            <CustomerReportsDetailBody />
        </MainLayout>
    );
};

export default CustomerReportsDetail;

const CustomerReportsDetailBody = observer(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const [customerReport, setCustomerReport] = useState<CustomerReport>();

    useEffect(() => {
        if (location.state) {
            setCustomerReport(location.state as CustomerReport);
        }
    }, [location.state]);

    const handleWriteReply = () => {
        navigate("/homepage/reports/reply", { state: customerReport });
    };

    const handleNavigateToList = () => {
        navigate("/homepage/reports");
    };

    return (
        <div
            style={{
                width: "100%",
                minHeight: `calc(100vh - ${MAIN_RIGHT_TOP_HEIGHT})`,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <VerticalLayout height={"auto"} paddingLeft={36} paddingRight={36}>
                <TitleLargeMedium>BB열린소리 상세</TitleLargeMedium>
                <BTBox height="24px" />
                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                {customerReport ? (
                    <VerticalLayout height={"auto"} paddingBottom={36}>
                        {/* 작성자 정보 */}
                        <TitleMediumBold style={{ marginTop: "20px" }}>작성자 정보</TitleMediumBold>
                        <BTBox height="16px" />
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                marginTop: "8px",
                                marginBottom: "16px",
                                fontSize: "14px",
                                color: "#6C757D",
                                alignItems: "center",
                                flexWrap: "wrap",
                            }}
                        >
                            <b>작성자</b>
                            <div>{customerReport.requestorName}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>접수일</b>
                            <div>{formatDateToYMD(customerReport.createdAt)}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>생년월일</b>
                            <div>{formatDateToYMD(customerReport.dateOfBirth)}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>휴대폰번호</b>
                            <div>{customerReport.mobileNo}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>이메일</b>
                            <div>{customerReport.email}</div>
                        </div>

                        <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                        {/* 부가 정보 */}
                        <TitleMediumBold style={{ marginTop: "20px" }}>부가 정보</TitleMediumBold>
                        <BTBox height="16px" />
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                marginTop: "8px",
                                marginBottom: "16px",
                                fontSize: "14px",
                                color: "#6C757D",
                                alignItems: "center",
                            }}
                        >
                            <b>개인정보 제공 동의 여부</b>
                            <div>{customerReport.collectInfoAgreeYn ? "✅" : "❌"}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>답변 여부</b>
                            <div>{customerReport.replyCompletedYn ? "✅" : "❌"}</div>
                        </div>

                        <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                        {/* 신고 정보 */}
                        <TitleMediumBold style={{ marginTop: "20px" }}>신고 정보</TitleMediumBold>
                        <BTBox height="16px" />

                        {/* 제목 */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "center",
                                marginTop: "8px",
                                fontSize: "14px",
                                color: "#6C757D",
                                width: "100%"
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "700",
                                    minWidth: "48px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                }}
                            >
                                제목
                            </div>
                            <div style={{ flex: 1 }}>
                                <BTInputBox value={customerReport.title} disabled />
                            </div>
                        </div>

                        {/* 본문 */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "flex-start",
                                marginTop: "8px",
                                fontSize: "14px",
                                color: "#6C757D",
                                width: "100%"
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "700",
                                    minWidth: "48px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                }}
                            >
                                본문
                            </div>
                            <div style={{ flex: 1 }}>
                                <BTMultilineInputBox
                                    value={customerReport.contents}
                                    disabled
                                    style={{ width: '100%', boxSizing: 'border-box' }}
                                />
                            </div>
                        </div>

                        {/* 답변 정보 */}
                        {customerReport.replyCompletedYn && (
                            <VerticalLayout>
                                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />
                                <TitleMediumBold style={{ marginTop: "20px" }}>답변 정보</TitleMediumBold>
                                <BTBox height="16px" />

                                {/* 답변 제목 */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "16px",
                                        alignItems: "center",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        color: "#6C757D",
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: "700",
                                            minWidth: "48px",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                        }}
                                    >
                                        제목
                                    </div>
                                    <BTInputBox value={customerReport.replyTitle} disabled />
                                </div>

                                {/* 답변 본문 */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "16px",
                                        alignItems: "flex-start",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        color: "#6C757D",
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: "700",
                                            minWidth: "48px",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                        }}
                                    >
                                        본문
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <BTMultilineInputBox
                                            value={customerReport.replyContents}
                                            disabled
                                            style={{ width: '100%', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>
                            </VerticalLayout>
                        )}
                    </VerticalLayout>
                ) : (
                    <div style={{ fontSize: "16px", color: "#999" }}>
                        조회할 신고건이 없습니다.
                    </div>
                )}
            </VerticalLayout>

            {/* 버튼 영역 */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "40px",
                    marginLeft: "72px",
                    marginRight: "72px",
                }}
            >
                <div style={{ display: "flex", gap: "24px" }}>
                    {!customerReport?.replyCompletedYn && (
                        <BTButton color={theme.colors.bbTech} textColor="white" onClick={handleWriteReply}>
                            답변 보내기
                        </BTButton>
                    )}
                    <BTButton onClick={handleNavigateToList}>목록</BTButton>
                </div>
            </div>
        </div>
    );
});